module.exports = __webpack_public_path__ + "static/media/Avenir-Light.33f6570a.ttf";